module.exports = __webpack_public_path__ + "img/EC.448e8621.png";